export default "__VITE_PUBLIC_ASSET__4705ac36__"